import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, AlertController } from 'ionic-angular';
import { AngularFirestore } from 'angularfire2/firestore';

@IonicPage()
@Component({
  selector: 'page-edit-popover',
  templateUrl: 'edit-popover.html',
})
export class EditPopoverPage {

  allAssets: any;
  contact_id: any;
  view_contact: any;
  SDF_form_document_id: any;
  contact_type: any;
  secondary_found: any;
  realEstateFound: any;
  primary_secondary_found: any;
  primary_secondary_uid: any;
  tentativeRealEstateFound: any;
  userRole: any;
  totalChangeLog: number;
  public userData: any;
  

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public db: AngularFirestore,
    public alertCtrl: AlertController
    ) {
      this.userData = [];
      this.userRole = window.localStorage.getItem("userRole");

      this.contact_id = this.navParams.get('contact_uid');
      this.view_contact = this.navParams.get('view_contact');
      this.SDF_form_document_id = this.navParams.get('SDF_form_document_id');
      this.contact_type = this.navParams.get('contact_type');

      console.log(this.contact_id)
      console.log(this.view_contact)
      console.log(this.SDF_form_document_id)
      console.log(this.contact_type)
      this.primary_secondary_found = this.contact_type;
      this.SDF_form_document_id = this.SDF_form_document_id;

      this.checkSecondaryContact(this.contact_id).subscribe((data2)=>{
        this.secondary_found = '';
        if(data2.length > 0){
          if(data2[0].deleted == 1){
            this.secondary_found = 'deleted';
          }else{
            this.secondary_found = data2[0].uid;
          }
        }
      });
      
      this.getRealestateFound(this.contact_id).subscribe((data1)=>{
        this.realEstateFound = 0;
        if(data1.length > 0){
          this.realEstateFound = data1.length;
        }else{
          this.getRealestateFounds(this.contact_id).subscribe((data1)=>{
            this.realEstateFound = 0;
            if(data1.length > 0){
              this.realEstateFound = data1.length;
            }
          });
        }
      });

      this.gettentativeRealEstateFound(this.contact_id).subscribe((data1)=>{
        this.tentativeRealEstateFound = 0;
        if(data1.length > 0){
          this.tentativeRealEstateFound = data1.length;
        }else{
          this.gettentativeRealEstateFounds(this.contact_id).subscribe((data1)=>{
            this.tentativeRealEstateFound = 0;
            if(data1.length > 0){
              this.tentativeRealEstateFound = data1.length;
            }
          });
        }
      });

      this.getChangeLog(this.contact_id).subscribe((data)=>{
        this.totalChangeLog = data.length;
      });
  }
  
  checkPrimarySecondaryContact (contact_id){
    return this.db.collection<any>( "users_data", ref => ref.where('uid','==',contact_id )).valueChanges ();
  }

  checkSecondaryContact (contact_id){
    return this.db.collection<any>( "users", ref => ref.where('main_contact_uid','==',contact_id )).valueChanges ();
  }

  getRealestateFound (contact_id){
    return this.db.collection<any>( "SDF_realestate" , ref => ref.where('primary_uid','==', contact_id)).valueChanges ();
  }

  getRealestateFounds (contact_id){
    return this.db.collection<any>( "SDF_realestate" , ref => ref.where('secondary_uid','==', contact_id)).valueChanges ();
  }

  gettentativeRealEstateFound (contact_id){
    return this.db.collection<any>( "tentative_real_estate" , ref => ref.where('primary_uid','==', contact_id)).valueChanges ();
  }

  gettentativeRealEstateFounds (contact_id){
    return this.db.collection<any>( "tentative_real_estate" , ref => ref.where('secondary_uid','==', contact_id)).valueChanges ();
  }

  getChangeLog (contact_id){
    return this.db.collection<any>( "changed_log" , ref => ref.where('contact_uid','==', contact_id)).valueChanges ();
  }
  ionViewDidLoad() {
  }

  closePopover(){
    window.localStorage.removeItem("contact_uid");
    window.localStorage.removeItem("contact_second_uid");
    this.viewCtrl.dismiss();
  }
  moreAction(event, contact_uid, SDF_form_document_id, type){
    console.log('contact_uid', contact_uid)
    console.log('SDF_form_document_id', SDF_form_document_id)
    console.log('type', type)
    let contact_id = null;
    let second_contact_id = null;
    if(this.primary_secondary_found == 'Secondary Contact'){
      contact_id = this.primary_secondary_uid;
      second_contact_id = this.navParams.get('contact_uid');
    }else{
      contact_id = this.navParams.get('contact_uid');
      second_contact_id = this.secondary_found;
    }
    this.viewCtrl.dismiss({'contact_uid' : contact_uid, 'type' : type, 'contact_id_add_real_estate' : contact_id, 'second_contact_id' : second_contact_id, 'userData' : this.userData, 'SDF_form_document_id': SDF_form_document_id});
  }

  deletedContactPopup(event){
    this.viewCtrl.dismiss();
    let alert = this.alertCtrl.create({
      title: 'Message',
      message: 'Please contact admin to restore this “Contact”.',
      buttons: [
          {
              text: 'OK',
              handler: () => {
                  console.log('Cancel clicked');
              }
          }
      ]
    });
    alert.present();    
  }
}



// WEBPACK FOOTER //
// ./src/pages/edit-popover/edit-popover.ts